import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import { noop } from 'Helpers/PropTypes';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import ToggleAttributeButton from 'Components/ComponentLibrary/Molecules/ToggleAttributeButton/ToggleAttributeButton';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { DataValueMap } from 'Helpers/Testing';

const useStyles = buildUseStyles('ToggleStarredButton', () => ({
  root: {},
  fullWidth: {
    width: '100%',
    justifyContent: 'left',
  },
}));

const ToggleStarredButton = ({
  className,
  onChange, // This is onChange because MetaControl passes in an on change for a toggleable field
  value: isStarred,
  color,
  size,
  fullWidth,
  showLabel,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const buttonToolTipText = 'Favorite';

  return (
    <Tooltip
      title={buttonToolTipText}
      placement="top"
    >
      {/* The box is only here because Tooltip doesn't work without it due to the button having its own hover events */}
      {/* See: https://stackoverflow.com/questions/48930334/mui-next-tooltip-does-not-show-on-hover */}
      <Box className={classNames(className, classes.root)}>
        <ToggleAttributeButton
          className={classNames({
            [classes.fullWidth]: fullWidth,
          })}
          value={isStarred}
          icon={StarIcon}
          secondaryIcon={StarBorderIcon}
          onChange={onChange}
          color={color}
          size={size}
          label={showLabel ? buttonToolTipText : null}
          dataTestKeys={DataValueMap.init('toggle-starred-button').build()}
        />
      </Box>
    </Tooltip>
  );
};

ToggleStarredButton.defaultProps = {
  className: '',
  onChange: noop,
  color: 'primary',
  size: 'default',
  fullWidth: false,
  showLabel: false,
};

ToggleStarredButton.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.bool.isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
  fullWidth: PropTypes.bool,
  showLabel: PropTypes.bool,
};

export default ToggleStarredButton;
